import { IComponentController } from 'angular';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrence, IMonoOccurrenceOptions  } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireGroupeClass } from '../../../../../core/services/formulaire/formulaire-groupe.service';
import { IFormulaireGroupeAccordeonClass } from '../../../../../core/services/formulaire/formulaire-groupe-accordeon.service';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IStateService } from 'angular-ui-router';

interface IPageRc0001 extends IComponentController {
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
    multiOccurrenceDOIOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Rc0001Controller(
    mc1014Route: IRoute,
    ecranDetails: IEcranDetailsResourcesEntite,
    Formulaire: IFormulaireClass,
    $stateParams: any,
    MenuItemForage: IMenuItemForageClass,
    MenuItemEcran: IMenuItemEcranClass,
    MenuItemAction: IMenuItemActionClass,
    FormulaireGroupe: IFormulaireGroupeClass,
    FormulaireGroupeAccordeon: IFormulaireGroupeAccordeonClass,
    FormulaireItem: IFormulaireItemClass,
    $state: IStateService,
    ac0010Route: IRoute,
    rc0011Route: IRoute,
    rc2000Route: IRoute) {

    const vm: IPageRc0001 = this;
    vm.valeursEcran = ecranDetails.valeurs;

    const docAchat = [
        new MenuItemForage(
            'BTN_FORAGE_PFL',
            ac0010Route.NAME,
            (data: any) => ({
                id: data.doccleintref
            }),
            {
                fonction: 'BOUDAC',
                icon: 'exit_to_app'
            }
        )
    ];

    vm.monoOccurrenceOptions = {
        fonctions: {
            boutonDupliquer: false
        },
        cycleErrorReloadBlocs: ['rci'],
        infosMonetaires: {
            blocs: ['rci'],
            donnees:
                [
                    { nom: 'txmmntrec', libelle: 'TXMMNTREC' },
                    { nom: 'devtaucou', libelle: 'DEVTAUCOU' }
                ]
        },
        menus: [
            new MenuItemEcran(
                'LBL_BTN_TOLERANCE',
                mc1014Route.NAME,
                () => ({
                    tolcleintref: vm.monoOccurrence.data.txmcleint,
                    vaeustent: 'TXM',
                    indfor: vm.monoOccurrence.data.indfor
                }),
                {
                    fonction: 'BOUTOL',
                    icon: 'data_usage',
                    iconButton: false,
                    secondaire: true
                }
            ),
            new MenuItemEcran(
                'LBL_BTN_CREATION_RAPIDE',
                rc2000Route.NAME,
                () => ({
                }),
                {
                    fonction: 'BOUCRERAP',
                    icon: 'data_usage',
                    iconButton: false,
                    secondaire: true
                }
            ),
            new MenuItemForage(
                'LBL_BTN_DISTRIBUTION',
                rc0011Route.NAME,
                () => ({
                    id: vm.monoOccurrence.data.txmcleint
                }),
                {
                    fonction: 'BOUDIS',
                    icon: 'exit_to_app',
                    iconButton: false,
                    secondaire: true,
                    hidden: () => ecranDetails.valeurs.inddisnew
                }
            ),
            new MenuItemAction(
                'LBL_BTN_DISTRIBUTION',
                'BOUDIS',
                () => ({}),
                {
                    fonction: 'BOUDIS',
                    icon: 'exit_to_app',
                    iconButton: false,
                    secondaire: true,
                    messageConfirmation: 'BOUDIS_MESSAGE',
                    hidden: () => !ecranDetails.valeurs.inddisnew,
                    successAction: (retour: any) => {
                        $state.go(rc0011Route.NAME, {
                            id: vm.monoOccurrence.data.txmcleint,
                            menuId: $stateParams.menuId
                        });
                    }
                }
            )
        ],
        formulaire: new Formulaire('LBL_BLC_TXM', [
            new FormulaireItem('txmnumdoc'),
            new FormulaireItem('txmnumdocseq'),
            new FormulaireItem('txmflgpij'),
            new FormulaireItem('tydcleint'),
            new FormulaireItem('txmnumref'),
            new FormulaireItem('txmflgrup'),
            new FormulaireItem('doccleintref', { menu: docAchat }),
            new FormulaireItem('refcleint'),
            new FormulaireItem('txmflgruprec'),
            new FormulaireItem('peccleint', { readonly: !vm.valeursEcran.flgsaiperdec  }),
        //    new FormulaireItem('peccod', { hidden:   vm.valeursEcran=== 1 }),
            new FormulaireItem('txmdat'),
            new FormulaireItem('txmdatreq'),
            new FormulaireItem('txmdsc', { largeur: 66.66 }),
            new FormulaireItem('aut__txmflgmulloc'),
            new FormulaireGroupeAccordeon('LBL_AUTRE', new Formulaire([
                new FormulaireGroupe('', new Formulaire([
                    new FormulaireItem('txmnomtra'),
                    new FormulaireItem('txmnumemb'),
                    new FormulaireItem('txmnbrcolrec'),
                    new FormulaireItem('txmnbrcolliv')
                ], { largeurDefaut: 100 }), { largeur: 33.33 }),
                new FormulaireGroupe('', new Formulaire([
                    new FormulaireItem('vectxmcat'),
                    new FormulaireItem('lipcleint'),
                    new FormulaireItem('dacatt')
                ], { largeurDefaut: 100 }), { largeur: 33.33 }),
                new FormulaireGroupe('', new Formulaire([
                    new FormulaireItem('ltrcod', { default: ecranDetails.valeurs.ltrcod }),
                    new FormulaireItem('intcleintreq'),
                    new FormulaireItem('intcleintdem')
                ], { largeurDefaut: 100 }), { largeur: 33.33 })
            ]))
        ], { largeurDefaut: 33.33 })
    };

    vm.rciMultiOccurrenceOptions = {
        bloc: 'rci',
        editionRapideActive: true,
        fonctions: {
            editionRapide: true,
            boutonDupliquer: false
        },
        colonnesFixesGauche: [
            { nom: 'dailig', largeur: 100 },
            { nom: 'daidsc', largeur: 300 }
        ],
        colonnesFixesDroite: [
            { nom: 'rciflgfer', largeur: 100 },
            { nom: 'rciflgmsg', largeur: 100 }
        ],
        colonnesVisibles: [
            { nom: 'dsclng', largeur: 100 , isIcon: [{
                    value: '',
                    toujoursVisible: true,
                    indicateurDeDonnees: true,
                    iconIndicateurClass:'ex-grid-col-setColorVert ex-input-description-bouton-texte-long',

                    icon: "description",
                    iconTitleData: true,
                    iconTitleChamp: 'dsclng',
                    iconClass: 'ex-input-description-bouton-texte-long',
                    iconAfficherTooltip: true,

                    hasLibelle: true,
                    champLibelle: "",
                    constantLibelle: "dsclng",
                    hasModal: true
                }] },
            { nom: 'daiqte', largeur: 126 },
            { nom: 'rciqte', largeur: 126 },
            { nom: 'rciqterup', largeur: 126 },
            { nom: 'rciqteruprec', largeur: 126 },
            { nom: 'forcod', largeur: 120 },
            { nom: 'fordsc', largeur: 180 },
            { nom: 'rcicom', largeur: 210 }
        ],
        colonnesEditionRapide: [
            { nom: 'rciligref', largeur: 100, resourceParams: () => ({ doccleint: $stateParams.id }) },
            { nom: 'daidsc', largeur: 100 },
            { nom: 'dsclng', largeur: 100, isIcon: [{
                    value: '',
                    toujoursVisible: true,
                    indicateurDeDonnees: true,
                    iconIndicateurClass:'ex-grid-col-setColorVert ex-input-description-bouton-texte-long',

                    icon: "description",
                    iconTitleData: true,
                    iconTitleChamp: 'dsclng',
                    iconClass: 'ex-input-description-bouton-texte-long',
                    iconAfficherTooltip: true,

                    hasLibelle: true,
                    champLibelle: "",
                    constantLibelle: "dsclng",
                    hasModal: true
                }]  },
            { nom: 'daiqte', largeur: 126 },
            { nom: 'rciqte', largeur: 126 },
            { nom: 'rciqterup', largeur: 126 },
            { nom: 'rciqteruprec', largeur: 126 },
            { nom: 'rciflgfer', largeur: 100 },
            { nom: 'rcicom', largeur: 100 },
            { nom: 'rcimsg', largeur: 210 }
        ],
        colonnesCachees: [ 'rcicleint'],
        formulaire: new Formulaire([
            new FormulaireItem('rciligref', { required: true, largeur: 50, resourceParams: () => ({ doccleint: $stateParams.id }) }),
            new FormulaireItem('daidsc'),
            new FormulaireItem('rcimsg'),
            new FormulaireItem('dsclng', { largeur: 50  ,
                  affichageBoutonTexteLong: {
                    active: true,
                    modaleOptions: {
                        titre: 'G_LBL_TITRE_MODAL_TEXTE_LONG_AC0010',
                        icon: 'article',
                        largeur: 50
                    },
                    champOptions: {
                        enableCount: true,
                        largeur: 100,
                        showTooltip: true
                    }
                }}),
            new FormulaireItem('daiqte'),
            new FormulaireItem('rciqte'),
            new FormulaireItem('rciqterup'),
            new FormulaireItem('rciqteruprec'),
            new FormulaireItem('rciflgfer'),
            new FormulaireItem('rcicom', { largeur: 100 })
        ], { largeurDefaut: 25 })
    };
}
